import { render, staticRenderFns } from "./report.recipientsSummary.vue?vue&type=template&id=7c89ce1c&lang=pug"
import script from "./report.recipientsSummary.vue?vue&type=script&lang=js"
export * from "./report.recipientsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports